<template>
  <div class="blue-grey lighten-3 rounded d-flex align-start px-2 py-1">
    <p
      class="ma-0 pa-0 font-size-10 font-weight-400 blue-grey--text text--darken-1"
      style="line-height: 14px; letter-spacing: 0.4px;"
    >
      {{ $t('insights.global_average') }}
      <span class="font-weight-700"> {{ formatNumber(globalData) }}. </span>
      {{ comparePre }}
      <span
        class="font-weight-700"
        :class="{
          'green--text': compareDifference > 0,
          'red--text': compareDifference < 0,
        }"
      >
        {{ ` ${formatNumber(compareDifference)} ` }} </span
      >{{ $t('insights.compare_global_post') }}
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CompareData',

  props: {
    type: String,
    globalData: Number,
    compareDifference: Number,
  },

  computed: {
    ...mapGetters(['language', 'account']),

    comparePre() {
      const copy =
        this.account.isAdmin || this.account.isOrganizationAdmin
          ? 'compare_global_admin'
          : 'compare_global'

      return this.$t(`insights.${copy}_${this.type}`)
    },
  },

  methods: {
    formatNumber(value) {
      const abreviatedValue = Intl.NumberFormat('en-us', {
        notation: 'compact',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value)
      return abreviatedValue
    },
  },
}
</script>
